import { slugs } from '@/constants/slugs'
import { QuantityMultiplier } from './types'

export const QUANTITY_MULTIPLIERS: Record<string, QuantityMultiplier[]> = {
  [slugs.kingOfKings]: [
    { min: 1, max: 2, multiplier: 2 },
    { min: 3, max: 4, multiplier: 3 },
    { min: 5, max: 9, multiplier: 5 },
    { min: 10, max: 24, multiplier: 10 },
    { min: 25, max: Infinity, multiplier: 25 },
  ],
  [slugs.theLastRodeo]: [
    { min: 1, max: 2, multiplier: 2 },
    { min: 3, max: 4, multiplier: 3 },
    { min: 5, max: 9, multiplier: 5 },
    { min: 10, max: 24, multiplier: 10 },
    { min: 25, max: Infinity, multiplier: 25 },
  ],
  [slugs.sketch]: [
    { min: 1, max: 2, multiplier: 2 },
    { min: 3, max: 4, multiplier: 3 },
    { min: 5, max: 9, multiplier: 5 },
    { min: 10, max: 24, multiplier: 10 },
    { min: 25, max: Infinity, multiplier: 25 },
  ],
  [slugs.senior]: [
    { min: 1, max: 2, multiplier: 2 },
    { min: 3, max: 4, multiplier: 3 },
    { min: 5, max: 9, multiplier: 5 },
    { min: 10, max: 24, multiplier: 10 },
    { min: 25, max: Infinity, multiplier: 25 },
  ],
  [slugs.david]: [
    { min: 1, max: 2, multiplier: 2 },
    { min: 3, max: 4, multiplier: 3 },
    { min: 5, max: 9, multiplier: 5 },
    { min: 10, max: 24, multiplier: 10 },
    { min: 25, max: Infinity, multiplier: 25 },
  ],
}

export const getQuantityMultiplier = (theatricalSlug: string, quantity: number): number => {
  const multipliers = QUANTITY_MULTIPLIERS[theatricalSlug]
  if (!multipliers) return 1

  const multiplier = multipliers.find((m) => quantity >= m.min && quantity <= m.max)
  return multiplier?.multiplier ?? 1
}
